export const resetPassword = {
  header: 'Reset Password',
  prompt: 'Please enter your new password using the security guidelines below.',
  newPasswordLabel: 'New password',
  confirmPasswordLabel: 'Confirm new password',
  updatePassword: 'Update password',
  guidelines: {
    lowercase: 'lowercase',
    numbers: 'numbers (0-9)',
    uppercase: 'uppercase',
    minimumLength: '%minimumLength%+ characters'
  },
  successMessage: 'Your password has been reset.'
};
